import { useEffect, useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import api from '../../connection/api';
import axios from 'axios';
import alert_box from '../../alert/alert_box';



function Login({ onBack }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  // const { login } = useAuth();
  const navigate = useNavigate();
  const [formdata, setFormdata] = useState({
    email: '',
    password: '',
  }); 

  useEffect(()=>{
    if(localStorage.getItem('token')){
      if(localStorage.getItem('role')==='admin'){
        navigate('/admin/dashboard');
      }
      else if(localStorage.getItem('role')==='user'){
        navigate('/chawder/Home');
      }
      // getIP();
    }
  },[])

  
  const login= async(e)=>{
    e.preventDefault();
   try {
    
   

     const response = await api.post('/login', {
        email:formdata.email,
        password: formdata.password, 
    });
    // console.log( );
    if (response.data.success===true) {
      const baseName = response.data.user.base[0].base_name || ''; 
      const circleName = response.data.user.circle[0].circle_name || '';
      const userName = response.data.user.name || '';
//  console.log('base_id'+response.data.data);
      const token = response.data.token;
      const role = response.data.user.role;
      const user_id = response.data?.user?.base_id;
 
      localStorage.setItem("token", token);
      localStorage.setItem("role", role);
      localStorage.setItem("user_id", user_id);
      localStorage.setItem("bnka", baseName);
      localStorage.setItem("bazna", circleName);
      localStorage.setItem("username", userName);
      localStorage.setItem("base_id", response.data?.user?.base_id);

  if (role==="admin" || role==="superadmin") {
    navigate('/admin/dashboard');
  }
  else if (role==="user") {
    
// console.log("user");
navigate('../chawder/Home');
    }
    
    }
    else{
// setError(response);
// setError(response.data.message);
alert_box('هەڵە ڕویدا',response.data.message,'error','ok');

    }
  } catch (error) {
// setError(error);
// setError(error.response.data.message);
alert_box('هەڵە ڕویدا',error,'error','ok');
    
  }

}

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormdata((prev) => ({ ...prev, [name]: value }));
    
};     

  return (
    <div className="login-container">
      <div className="login-form">
         <h2>چوونەژوورەوە</h2>
        {error && <div className="error-message">{error}</div>}

        <form onSubmit={login}>
          <div className="form-group">
            <label htmlFor="email">ئیمەیڵ</label>
            <input
              value={formdata.email}
              onChange={handleChange}
              type="email"
              name='email'
              id="email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">وشەی نهێنی</label>
            <input
              value={formdata.password}
              onChange={handleChange}
              type="password"
              name='password'
              id="password"
              required
            />
          </div>
          <button type="submit" className="login-button">چوونەژوورەوە</button>
        </form>
      </div>
    </div>
  );


}

export default Login;
